/* eslint-disable react-hooks/exhaustive-deps */
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ReplayIcon from '@mui/icons-material/Replay';
import {
  Button,
  IconButton,
  Menu,
  MenuItem,
  Stack
} from '@mui/material';
import { get, isEmpty, map } from "lodash";
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';

import Alert from "../../../components/form/Alert";
import Notification from "../../../components/form/Notification";
import Question from "../../../components/form/Question";
import Table from "../../../components/form/Table";
import CostsModal from "./CostsModal";
import AddIcon from '@mui/icons-material/Add';

import CostEditModal from './CostEditModal';

import { getCostProvider } from "../../../store/transactions/thunk/costProvider/getAll";
import { deleteRouteCost } from "../../../store/transactions/thunk/route/deleteCost";
import { getRouteId } from "../../../store/transactions/thunk/route/getId";
import { putRouteCost } from "../../../store/transactions/thunk/route/putCost";
import { useCanView } from "../../../config/hook/UserPermissions";

const Costs = ({ setBtns, isEdit }) => {
  const [__] = useTranslation("route");
  const [__c] = useTranslation("cost");
  const { id } = useParams();
  const dispatch = useDispatch();
  const canView = useCanView();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" })
  const [openModal, setOpenModal] = useState(false);
  const [costsSelected, setCostsSelected] = useState([])
  const [openQuestion, setOpenQuestion] = useState(null);
  const [toSelected, setToSelected] = useState({});
  const [toEdit, setToEdit] = useState({});
  const [valueAmount, setValueAmount] = useState();
  const [openModalEdit, setOpenModalEdit] = useState(false);

  const route = useSelector(state => state.transactions.route.costAll);
  const actualCosts = useSelector(state => state.transactions.route.costAll);
  const put = useSelector(state => state.transactions.route.putCost);
  const delet = useSelector(state => state.transactions.route.deleteCost)
  const post = useSelector(state => state.transactions.route.postCost);
  const currentRoute = useSelector((state) => state.transactions.route.detail);
  const costProvider = useSelector(state => state.transactions.costProvider);
  const putCost = useSelector(state => state.transactions.route.putCost);

  const getData = () => {
    dispatch(getRouteId(id ))
  }
  
  const getDataCost = (idProvider) => {
    dispatch(getCostProvider({ idProvider }));
  }

  const reload = () => getData();

  useEffect(() => {
    setAnchorEl(false)
    getData();
  }, [dispatch])

  useEffect(() => {
    const idProvider = get(currentRoute, "data.idProvider");
    if (get(currentRoute, "isSuccess") && idProvider > 0) {
      getDataCost(idProvider);
    }
  }, [get(currentRoute, "isSuccess"), get(currentRoute, "data.idProvider")])

  useEffect(() => {
    setCostsSelected(map(get(currentRoute, "data.routeBillings", []), ({ idTypeCost }) => idTypeCost))
  }, [get(route, "data.length")])

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
        {isEdit ? <Button className='w-[100px] min-w-[100px]' startIcon={<AddIcon/>} variant="contained" color="secondary" onClick={() => {
          if (canView("TRANSACCIONES/RUTAS/COSTOS", "add")) {
            setOpenModal(true)
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para agregar nuevos costos a la ruta.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }}>{__(`toolbar.add`)}</Button> : <div className='flex-1' />}
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [isEdit])

  const handleOpenMenu = (row) => (event) => {
    setToSelected(row)
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setToSelected({})
    setAnchorEl(null);
  };

  const onCancel = () => {
    setValueAmount(undefined)
    setToEdit({})
    setToSelected({})
    setOpenQuestion(false)
  }

  const onDelete = () => {
    dispatch(deleteRouteCost({ id: Number(get(toSelected, "id")), idRoute: Number(id) }))
    setSelected({})
    setOpenQuestion(false)
  }


  const handleDelete = (row) => () => {
    setAnchorEl(null);
    setOpenQuestion(true);
    setToSelected(row);
  };

  const handleUpdate = (row) => () => {
    setToEdit(row);
    setAnchorEl(null);
    setOpenModalEdit(true);
  };

  const HandelUpdateCost = (cost) => {
    dispatch(putRouteCost(cost));
  };

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(put, "isSuccess", false)) { onCancel(); setOpenModal(false); setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
    if (get(post, "isSuccess", false)) { setOpenModal(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "put") }
    if (get(putCost, "isSuccess", false)) { onCancel(); setOpenModal(false); setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "put" }) }
    if (get(putCost, "isReject", false)) { setError(get(putCost, "error", {}), "put") }
  }, [put, post, delet, putCost]);

  const headTable = [
    {
      key: "idCost",
      label: __(`table.colsCosts.idCost`),
      align: "center"
    },
    {
      key: "quantity",
      label: __(`table.colsCosts.quantity`),
      align: "center"
    },
    {
      key: "description",
      label: __(`table.colsCosts.description`),
      align: "center"
    },
    {
      key: "price",
      label: __(`table.colsCosts.price`),
      align: "center"
    },
    {
      ... (!isEdit ? {} :
        {
          key: "options",
          label: __(`table.colsCosts.options`),
          align: "center",
          sx: { position: "sticky", width: 100, right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
        }
      )
    },
  ]


  const dataTable = map(get(currentRoute, "data.routeCosts", []), (row, i) => ({
    ...row,
    // delete: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)} ><DeleteIcon fontSize="inherit" /></IconButton>
    price: `$ ${get(row, "price", 0)?.toFixed(2)}`,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))

  return (
    <div>
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(currentRoute, "isLoading", false)}
        empty="costs"
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={handleUpdate(toSelected)}>{__(`table.menu.edit`)}</MenuItem>
        <MenuItem onClick={ () => {
          if (canView("TRANSACCIONES/RUTAS/COSTOS", "delete")) { 
            handleDelete(toSelected)();
          } else {
            setAlert({
              open: true,
              title: "Permiso Denegado.",
              subtitle: (<ul> • No tienes permiso para eliminar costos de la ruta.</ul>),
              type: "error",
              btn: __(`${module}.actions.close`),
              func: closeAlert
            })
          }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <CostsModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        selected={costsSelected}
        setSelected={setCostsSelected}
      />
      <CostEditModal 
       __={__}
       open={openModalEdit}
       close={() => setOpenModalEdit(false)}
       selected={toEdit}
       update={HandelUpdateCost}
      />
      <Question
        title={__("alert.deleteCost")}
        detail={""}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </div >
  )
}

export default Costs;
